export const CATEGORIES_MANAGER_EDIT_CATEGORY = 'CATEGORIES_MANAGER_EDIT_CATEGORY';
export const CATEGORIES_MANAGER_DELETE_CATEGORY = 'CATEGORIES_MANAGER_DELETE_CATEGORY';
